import React from "react";
import {
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
} from "@heroui/react";


export default function LeadViewModal({
    title,
    children,
    handleConfirmUpdate,
    isOpen,
    onClose,
    modalFooter = true,
    confirmText = "Confirm",
    cancelText = "Cancel",
}) {
    return (
        <>
            {/* <Button onPress={onOpen}>Open Modal</Button> */}
            <Modal size="full" backdrop='blur' isOpen={isOpen} onClose={onClose} isDismissable={false} isKeyboardDismissDisabled={false} >
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1 border-b border-gray-100">
                                {title}
                            </ModalHeader>
                            <ModalBody className="p-0 py-4 px-6">
                                <div className="pb-4 w-full max-h-[800px] overflow-y-auto default-scrollbar">
                                    {children}
                                </div>
                            </ModalBody>

                            {modalFooter && (
                                <ModalFooter className="border-t border-gray-100">
                                    <Button color="primary" variant="flat" onPress={onClose}>
                                        <p className="text-primary-900">{cancelText}</p>
                                    </Button>
                                    <Button color="secondary" onPress={handleConfirmUpdate}>
                                        <p className="text-black">{confirmText}</p>
                                    </Button>
                                </ModalFooter>
                            )}
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    );
}